import { SetterOrUpdater } from "recoil";
interface RedirectProps {
  urlPath: string;
  historyState?: any;
  history?: any;
  usersTabs?: any;
  setSelectedIndex?: SetterOrUpdater<number>;
}
export function RedirectTo({
  urlPath,
  historyState,
  history,
  usersTabs,
  setSelectedIndex,
}: RedirectProps) {
  history.push({
    pathname: urlPath,
    state: historyState,
  });

  const index = usersTabs?.findIndex((c) => c.to === urlPath);

  setSelectedIndex && setSelectedIndex(index);
}
